import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import ProjectInstallmentFundingConditions from "../../../interfaces/project-installment-funding-conditions";
import ProjectInstallmentFundingConditionStatus from "../../../interfaces/project-installment-funding-condition-status";
import {EquityInstallmentService, UpdateInstallmentObservableMode} from "../../equity-installment.service";
import {Subscription} from "rxjs";
import ProjectInstallmentFundingConditionFile from "../../../interfaces/project-installment-funding-condition-file";
import ProjectInstallmentFundingConditionApproval
  from "../../../interfaces/project-installment-funding-condition-approval";
import {MatDialog} from "@angular/material/dialog";
import {
  EquityInstallmentApprovalLogsModalComponent
} from "../equity-installment-approval-logs-modal/equity-installment-approval-logs-modal.component";
import ProjectInstallmentFundingConditionApprovalLog
  from "../../../interfaces/project-installment-funding-condition-approval-log";
import ProjectInstallmentFundingConditionApprovalStatus
  from "../../../interfaces/project-installment-funding-condition-approval-status";
import {
  AddEquityInstallmentMode,
  AddInstallmentFundingModalComponent
} from "../add-installment-funding-modal/add-installment-funding-modal.component";
import ProjectInstallmentFundingConditionApprovalType
  from "../../../interfaces/project-installment-funding-condition-approval-type";
import {ConfirmationModalComponent} from "../../../components/confirmation-modal/confirmation-modal.component";
import {
  EquityInstallmentSharepointService
} from "../equity-installment-documents-panel/equity-installment-sharepoint.service";

@Component({
    selector: 'equity-installment-conditions',
    templateUrl: './equity-installment-conditions.component.html',
    styleUrls: ['./equity-installment-conditions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquityInstallmentConditionsComponent implements OnInit{
  @Input() condition:any;
  @Input() conditionForm: FormGroup
  @Input() readonly:boolean;
  @Input() isExpanded:boolean = false;
  @Input() highlight: boolean = false;
  @Input() allApproved: boolean = false;
  public readOnlyStatus: string | null = null;
  public conditionsStatuses:ProjectInstallmentFundingConditionStatus[] = []
  public approvalStatuses: ProjectInstallmentFundingConditionApprovalStatus[] = []
  public approvalTypes: ProjectInstallmentFundingConditionApprovalType[] = []
  public approvalsSub: Subscription
  public filesSub: Subscription
  public projectSub: Subscription
  public statusSub: Subscription
  public approvalTypesSub: Subscription
  public approvalStatusSub: Subscription
  public userSub: Subscription
  public permissionsSub: Subscription
  public sharepointSub: Subscription
  public drawerEvent: Subscription
  public filesFromSharepointSelected:any[] = [];
  public hasSite:boolean;
  public openAdditionalNotes: boolean = false;
  public permissions:any;
  public user: any;
  public files:ProjectInstallmentFundingConditionFile[] = []
  public queuedFiles:FileList
  public approvedApproval:number = 0;
  public approvals:ProjectInstallmentFundingConditionApproval[] = []
  public approvalLogs:ProjectInstallmentFundingConditionApprovalLog[] = []
  public project:any
  public isDragging: boolean = false;
  public isLoading: boolean = false;
  public erroredFileNames: string[] = []
  public nameExpanded: boolean = false;
  public nicknameExpanded: boolean = false;
  public notesExpanded: boolean = false
  public additionalNotesExpanded:boolean = false;
  @Output('save') updateAllConditions: EventEmitter<any> = new EventEmitter<any>()
  @Output('remove') removeForm: EventEmitter<string> = new EventEmitter<string>()
  constructor(private equityService: EquityInstallmentService, private sharepointService: EquityInstallmentSharepointService ,private dialog: MatDialog) {
  }
  ngOnInit() {
    this.statusSub = this.equityService.projectInstallmentConditionStatuses$.subscribe((result) => {
      this.conditionsStatuses = result
    })
    this.approvalStatusSub = this.equityService.projectConditionApprovalStatuses$.subscribe((result) => {
      this.approvalStatuses = result;
    })
    this.approvalTypesSub = this.equityService.projectConditionApprovalTypes$.subscribe((result) => {
      this.approvalTypes = result;
    })

    this.approvalsSub = this.equityService.projectConditionApprovals$.subscribe((result) => {
      this.approvals = result[this.condition.id].sort((a: ProjectInstallmentFundingConditionApproval, b: ProjectInstallmentFundingConditionApproval) => {
        const nameA = a.projectInstallmentFundingConditionApprovalType?.name?.toLowerCase() || '';
        const nameB = b.projectInstallmentFundingConditionApprovalType?.name?.toLowerCase() || '';
        return nameA.localeCompare(nameB);
      })
      this.approvedApproval = this.approvals.filter((approval: ProjectInstallmentFundingConditionApproval) =>
        approval.projectInstallmentFundingConditionApprovalStatus?.name.toLowerCase() == 'approved'
      ).length
    })

    this.filesSub = this.equityService.projectConditionFiles$.subscribe((result) => {
      this.files = result[this.condition.id]
    })

    this.userSub = this.equityService.user$.subscribe((result) => this.user = result);
    this.projectSub = this.equityService.project$.subscribe((result) => this.project = result)
    this.sharepointSub = this.sharepointService.siteId$.subscribe((result) => {
      if(result!==null){
        this.hasSite = true;
      }
    })
    this.drawerEvent = this.sharepointService.fileSelected.subscribe((result) => {
      this.filesFromSharepointSelected = result
    })
    this.permissionsSub = this.equityService.permissions$.subscribe((result) => this.permissions = result)
    this._setConditionForm(this.condition)
    this.equityService.setErroredFiles(this.condition.projectInstallmentFundingConditionFiles, this.condition.projectInstallmentFunding.id, this.condition.id)
    this.approvalLogs.push(...this.condition.projectInstallmentFundingConditionApprovalLogs)
    this.equityService.erroredFiles$.subscribe((result) => {
      if(result.hasOwnProperty(this.condition.projectInstallmentFunding.id) && result[this.condition.projectInstallmentFunding.id].hasOwnProperty(this.condition.id)
      && result[this.condition.projectInstallmentFunding.id][this.condition.id].length > 0){
        this.erroredFileNames.push(...result[this.condition.projectInstallmentFunding.id][this.condition.id])
      }
    })

    if(this.condition.additional_notes){
      this.openAdditionalNotes = true;
    }


  }

  public get isAllApproved(): boolean {
    return this.approvals.length > 0 && this.approvedApproval === this.approvals.length;
  }

  private _setConditionForm(condition: ProjectInstallmentFundingConditions){
    this.readOnlyStatus = condition.projectInstallmentFundingConditionStatus!== null ? condition.projectInstallmentFundingConditionStatus.name : 'Due';
  }

  updateConditionApprovals(){
    this.updateAllConditions.emit()
  }

  public expandPanel(){
    this.isExpanded = !this.isExpanded
  }

  public openLogModal(){
    let dialogRef = this.dialog.open(EquityInstallmentApprovalLogsModalComponent, {
      width: '600px',
      data: {
        title: this.condition.nickname,
        subtitle: "Installment " + this.condition.projectInstallmentFunding.projectInstallment.installment_number + " - " + "Funding " + this.condition.projectInstallmentFunding.funding_number,
        condition_id: this.condition.id
        //logs: this.approvalLogs
      }
    })
  }

  public openDeleteConditionModal(){
    let dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '600px',
      height: '200px',
      data: {
        modalTitle: 'Delete Condition ' + this.condition.name,
        actionMessage: 'Are you sure you want to delete this funding condition?',
      }
    })

    dialogRef.afterClosed().subscribe((data) => {
      if(data.clicked === 'Ok'){
        this.equityService.deleteFundingCondition(this.condition.id).subscribe((response) => {
          this.removeForm.emit(this.condition.id)
          let rs = response as any;
          let resultData = rs.data.deleteProjectInstallmentCondition
          this.equityService.updateFundingConditions(UpdateInstallmentObservableMode.REMOVE, resultData)
        })
      }
    })
  }

  public validateErrorFiles(file:ProjectInstallmentFundingConditionFile){
    const normalizeFileName = (val?:string) => (val ?? '').trim().toLowerCase()
    return this.erroredFileNames.map(normalizeFileName).includes(normalizeFileName(file?.filename ?? ''))
  }


  public openAddApprovalModal(){
    let dialogRef = this.dialog.open(AddInstallmentFundingModalComponent, {
      width: '800px',
      data: {
        modalType: AddEquityInstallmentMode.APPROVAL,
        approvalTypes: this.approvalTypes
      }
    })
    let saveSub = dialogRef.componentInstance.save.subscribe((result) => {
      let approvalData = {
        project_installment_funding_condition_id: this.condition.id,
        project_installment_funding_condition_approval_type_id: result.approval_type
      }
      this.equityService.createConditionApproval(approvalData).subscribe((result) => {
        this.equityService.openSnackBar('Approval added.', 'save-success')
        let rs = result as any;
        let resultData = rs.data.createConditionApproval as ProjectInstallmentFundingConditionApproval
        this.equityService.updateConditionApprovals(UpdateInstallmentObservableMode.ADD, resultData)
        dialogRef.close()
        saveSub.unsubscribe()
      })
    })
  }

  public onDragOver(event:DragEvent){
    this.isDragging = true;
    event.preventDefault();
    event.stopPropagation();
  }

  public onDragLeave(event: DragEvent){
    this.isDragging = false;
    event.preventDefault();
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    this.isDragging = false;
    event.preventDefault();
    event.stopPropagation();
    if(!this.permissions.filePermissions._create){
      this.equityService.openSnackBar('Cannot upload file due to permissions error', 'save-warn')
      return;
    }
    if(event.dataTransfer?.files){
      this.queuedFiles = this._appendConditionNumberToFiles(event.dataTransfer.files)
    }
    this.uploadFiles()

  }

  public uploadFiles(){
    let savedFiles = 0;
    this.isLoading = true;
    this.sharepointService.openFolderFromFunding(
      this.condition.projectInstallmentFunding.projectInstallment.installment_number,
      this.condition.projectInstallmentFunding.funding_number
    )
    for(let i = 0 ; i < this.queuedFiles.length; i++){
      if(this.queuedFiles[i].size < 40000000){
        this.sharepointService.uploadFileToDrive(this.queuedFiles[i]).subscribe((response:any) => {
          let obj = {
            project_installment_funding_condition_id: this.condition.id,
            filename: response.name,
            fileurl: this.sharepointService.parseSharepointWebUrl(response)
          }
          this.equityService.createFundingConditionFile(obj).subscribe((result:any) => {
            savedFiles += 1;
            this.equityService.updateConditionFiles(UpdateInstallmentObservableMode.ADD, result.data.createConditionFile)
            if(savedFiles == this.queuedFiles.length){
              this.isLoading = false;
              let responsePath = response?.parentReference?.path.split("root:/")[1]
              this.equityService.openSnackBar('File(s) uploaded', 'save-success')
              this.sharepointService.navigateToFolder(responsePath)
            }
          })
        });
      } else {
        this.sharepointService.uploadLargeFileToDrive(this.queuedFiles[i])
      }
    }
  }

  public uploadFromDrive(){
    let uploadedFiles = 0;
    if(this.filesFromSharepointSelected.length==0){
      return;
    }
    for(let d = 0 ; d < this.filesFromSharepointSelected.length; d++){
      let obj = {
        project_installment_funding_condition_id: this.condition.id,
        filename: this.filesFromSharepointSelected[d].name,
        fileurl:this.filesFromSharepointSelected[d].webUrl
      }
      this.equityService.createFundingConditionFile(obj).subscribe((result:any) => {
        uploadedFiles + 1
        this.equityService.updateConditionFiles(UpdateInstallmentObservableMode.ADD, result.data.createConditionFile)
        if(uploadedFiles == this.filesFromSharepointSelected.length){
          this.equityService.openSnackBar("Files uploaded", "save-success")
        }
      })
    }
  }

  public browseFile(event: Event){
    const input = event.target as HTMLInputElement;
    if(!this.permissions.filePermissions._create){
      this.equityService.openSnackBar('Cannot upload file due to permissions error', 'save-warn')
      return;
    }
    if(input.files && input.files.length > 0){
      this.queuedFiles = this._appendConditionNumberToFiles(input.files)
      this.uploadFiles()
    }
  }


  private _appendConditionNumberToFiles(files: FileList): FileList {
    const dataTransfer = new DataTransfer();

    Array.from(files).forEach((file) => {
      const nameParts = file.name.split('.');
      const extension = nameParts.pop();
      const baseName = nameParts.join('.');

      const updatedName = `${this.condition.condition_number}-${baseName}.${extension}`;

      const newFile = new File([file], updatedName, { type: file.type });

      dataTransfer.items.add(newFile);
    });

    return dataTransfer.files;
  }


  ngOnDestroy(){
    this.statusSub.unsubscribe()
    this.approvalStatusSub.unsubscribe()
    this.filesSub.unsubscribe()
    this.approvalsSub.unsubscribe()
    this.approvalTypesSub.unsubscribe();
    this.userSub.unsubscribe();
    this.permissionsSub.unsubscribe();
    this.projectSub.unsubscribe();
  }

}
